
import React, { Fragment as F,
  useContext, useEffect, useLayoutEffect, useState,
} from 'react'
import {
  Link,
  useParams,
} from "react-router-dom"

import config from 'config'

import {
  useApiRouter,
  C,
  logg, loggt,
} from '$shared'
import {
  AppCtx,
} from '$src/App'

/**
 * ContactsList
**/
const ContactsList = (props) => {
  // logg(props, 'ContactsList')

  const apiRouter = useApiRouter()
  const params    = useParams()
  // logg(params, 'params')

  const {
    loading, setLoading,
    unauthorized, setUnauthorized,
  } = useContext(AppCtx)

  const [ contacts, setContacts ] = useState([])

  const defaultUnauthorizedBody = "<h1>Contacts</h1><p>We're sorry, but you don't have permissions to view this data</p><p>Please contact the sales team at <a href='mailto:info@fedfis.com'>info@fedfis.com</a>.</p>"
  const [ unauthorizedBody, setUnauthorizedBody ] = useState(".^.")

  useEffect(() => {
    // if (!params.rssd) { return }

    setLoading(true)
    fetch(apiRouter.bankContactsPath(params)
      ).then(r => {
        if (r.ok) {
          return r.json()
        } else {
          setUnauthorized(true)
          // fetch(`${config.drupalOrigin}/docpage/ContactsList-unauthorized?_format=json`).then(r => r.json()).then(inns => {
          //   setUnauthorizedBody(inns.body[0].value)
          // }).catch((err) => {
          //   setUnauthorizedBody(defaultUnauthorizedBody)
          // })
          throw "unauthorized"
        }
      }).then(({ rows }) => {
        setContacts(rows)
      }).catch((err) => {
        setUnauthorizedBody(<F>
          <p>Sorry, you don't have authorizaton to view this data.</p>
          <p>Please contact the <a href="mailto:info@fedfis.com">Sales</a> team to upgrade your account.</p>
        </F>)
        // loggt(err, 'cannot get BankContacts')
      }).finally(() => {
        setLoading(false)
      })
  }, [ params.rssd ])

  if (unauthorized) {
    return <div className='ContactsList'>
      {/* <div dangerouslySetInnerHTML={{ __html: unauthorizedBody }} ></div> */}
      { unauthorizedBody }
    </div>
  }

  if (!contacts.length) { return <F>.^.</F> }

  return <F>
    <div className='ScheduleShow' >
      <table className='bordered padded sticky'  >
        <thead>
          <tr>
            <th className='schedule-name' >
              <div className='d-flex' >
                <div className='flex-grow-1 text-center' >Contact Name</div>
              </div>
            </th>
            <th className=''>First Name</th>
            <th className=''>Last Name</th>
            <th className=''>Contact Title</th>
            <th className=''>Title Hierarchy</th>
            <th className=''>Title Role</th>
            <th className=''>Contact Email</th>
            <th className=''>LinkedIn Profile</th>
          </tr>

        </thead>
        <tbody>

          { contacts.map((item, idx) => <tr key={idx} >
            <th className='' >
              <div className='' >
                <div className='two align-left' >
                  { item['Contact Name'] }
                </div>
              </div>
            </th>
            <td >{ item['First Name'] }</td>
            <td >{ item['Last Name'] }</td>
            <td >{ item['Contact Title'] }</td>
            <td >{ item['Title Hierarchy'] }</td>
            <td >{ item['Title Role'] }</td>
            <td >{ item['Contact Email'] }</td>
            <td >{ item['LinkedIn Profile URLs'] ? <a href={ item['LinkedIn Profile URLs'] }>LinkedIn Profile</a> : null }</td>
          </tr> )}

        </tbody>
      </table>
    </div>
  </F>
}
export default ContactsList





